import type { FC, SVGProps } from "react";

const IconOpen: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M1.66699 1.66602H8.33366V8.33268" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.66699 8.33268L8.33366 1.66602" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconOpen
